/**
 * Centralized currency/GMV/number formatters.
 */

/** Format a price with full currency symbol (e.g. R$ 1.299,90 or $ 49.99) */
export function formatPrice(value: number, currency: 'BRL' | 'USD' = 'BRL'): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);
}

/** Format a number with pt-BR locale (e.g. 1.234) */
export function formatNumber(value: number): string {
  return new Intl.NumberFormat('pt-BR').format(value);
}

/** Format GMV from raw value (NOT cents) with compact symbol (K/M) */
export function formatGmvDisplay(value: number | null, currency: 'BRL' | 'USD' = 'USD'): string {
  if (!value) return '-';
  const symbol = currency === 'BRL' ? 'R$' : '$';
  if (value >= 1_000_000) return `${symbol}${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `${symbol}${(value / 1_000).toFixed(0)}K`;
  return `${symbol}${value.toFixed(0)}`;
}

/** Format GMV from cents (arsenal_creators stores gmv in cents) */
export function formatGmvFromCents(cents: number, currency: 'BRL' | 'USD' = 'BRL'): string {
  return formatGmvDisplay(cents / 100, currency);
}
